import QuizAttemptPage from '@/pages/children/student/quiz-attempt';
import { Routes } from '@/utils/constants';
import { lazy } from 'react';

export const OnboardingPage = lazy(() => import('../../pages/auth/onboarding'));
// const DashboardPage = lazy(() => import('../../pages/dashboard'));
const ChildrenPage = lazy(() => import('../../pages/children'));
const StudentProfilePage = lazy(
  () => import('../../pages/children/student/profile'),
);
const RealChildrenPage = lazy(() => import('../../pages/real-children'));
const ChildProfilePage = lazy(
  () => import('../../pages/children/child/profile'),
);
const SubscriptionPage = lazy(() => import('../../pages/subscription'));
const AccountPage = lazy(() => import('../../pages/account'));
const ViewHistoryPage = lazy(() => import('../../pages/leader-board'));

export const privateRoutes = [
  // {
  //   name: 'OnboardingPage',
  //   path: Routes.onboarding,
  //   component: OnboardingPage,
  // },
  // {
  //   name: 'DashboardPage',
  //   path: Routes.dashboard,
  //   component: DashboardPage,
  // },
  {
    name: 'LeaderBoardPage',
    path: Routes.performance,
    component: ViewHistoryPage,
  },
  {
    name: 'Children Page',
    path: Routes.children,
    component: ChildrenPage,
  },
  {
    name: 'Profiles Page',
    path: Routes.realChildren,
    component: RealChildrenPage,
  },
  {
    name: 'Profile Page',
    path: Routes.childProfile(),
    component: ChildProfilePage,
  },
  {
    name: 'Student Profile Page',
    path: Routes.studentProfile(),
    component: StudentProfilePage,
  },
  {
    name: 'Subscription',
    path: Routes.subscription,
    component: SubscriptionPage,
  },
  {
    name: 'AccountPage',
    path: Routes.account,
    component: AccountPage,
  },
  {
    name: 'Quiz Attempt Page',
    path: Routes.quizAttempt(),
    component: QuizAttemptPage,
  },
];
